import { render, staticRenderFns } from "./DuplicateCustomerDetails.vue?vue&type=template&id=080baade&scoped=true&"
import script from "./DuplicateCustomerDetails.vue?vue&type=script&lang=js&"
export * from "./DuplicateCustomerDetails.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateCustomerDetails.vue?vue&type=style&index=0&id=080baade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080baade",
  null
  
)

export default component.exports